import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Toast, ToastBody, ToastHeader } from 'reactstrap';

class VideoVisitToast extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        const { videoVisitToastr } = this.props;
        if (videoVisitToastr && videoVisitToastr !== prevProps.videoVisitToastr) {
            if (this.isToastOpen()) {
                logUI("UI.VideoVisitToast.Open", new Date(), Tools.getURLPath());
                const toastTimeout = setTimeout(() => {
                    if (this.isToastOpen()) {
                        this.closeToast();
                    }
                }, 6000);
                return () => clearTimeout(toastTimeout);
            }
        }
    }

    setVideoVisitToastrMsg(message, successStatus) {
        if (message) {
            const isSuccess = successStatus ? successStatus : false;
            this.props.setVideoVisitToastrMsg(message, isSuccess);
        }
    }

    isToastOpen() {
        const { videoVisitToastr } = this.props;
        return videoVisitToastr && videoVisitToastr.message && typeof videoVisitToastr.message !== 'undefined' && videoVisitToastr.message !== '' ? true : false;
    }

    closeToast() {
        const { videoVisitToastr } = this.props;
        const successStatus = videoVisitToastr && videoVisitToastr.successStatus ? videoVisitToastr.successStatus : false;
        this.props.setVideoVisitToastrMsg("", successStatus);
        logUI("UI.VideoVisitToast.Close", new Date(), Tools.getURLPath());
    }

    render() {
        const { videoVisitToastr } = this.props;
        const showToast = this.isToastOpen();
        const message = videoVisitToastr && videoVisitToastr.message ? videoVisitToastr.message : "";
        const successStatus = videoVisitToastr && videoVisitToastr.successStatus ? videoVisitToastr.successStatus : false;

        return (
            <Toast isOpen={showToast} className={`video-visit-toast-container ${successStatus ? "toast-msg-success" : "toast-msg-failure"}`}>
                <ToastHeader toggle={() => this.closeToast()}>
                    {message &&
                        <div className="details-icon-prepend">
                            <div className="icon-col">
                                <span className={successStatus ? "icon-list-check" : "icon-input-clear"} />
                            </div>
                            <div className="details-col">{message}</div>
                        </div>
                    }
                </ToastHeader>
            </Toast>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        videoVisitToastr: state.common.videoVisitToastr,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setVideoVisitToastrMsg: (message, successStatus) => dispatch({ type: types.SET_VIDEO_VISIT_TOASTR_MSG, message, successStatus })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoVisitToast));